export default class Slider {
    constructor(element, slideSelector = null) {
        this.element = element;
        this.slides = this.getSlides(element, slideSelector);
        this.activeIndex = 0;

        this.initializeStyle();
        this.render();

        window.addEventListener("resize", () => {
            this.initializeStyle()
            this.render()
        });
    }

    getSlides(element, selector) {
        if(selector === null) {
            return element.children;
        }

        return element.querySelectorAll(selector);
    }

    getContainerWidth() {
        return this.element.getBoundingClientRect().width;
    }

    initializeStyle() {
        this.element.style.position = "relative";

        for (var i = 0; i < this.slides.length; i++) {
            this.slides[i].style.position = "absolute";
            this.slides[i].style.top = "0";
            this.slides[i].style.left = "0";
            this.slides[i].style.width = this.getContainerWidth() + 'px';
            this.slides[i].style.height = "100%";
            this.slides[i].setAttribute("aria-hidden", "true");
        }
    }

    getTranslationForIndex(i) {
        var offsetFromActive = i - this.activeIndex;

        return this.getContainerWidth() * offsetFromActive;
    }

    render() {
        for (var i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transform = "translateX(" + this.getTranslationForIndex(i) + "px)";

            if(i !== this.activeIndex) {
                this.slides[i].setAttribute("aria-hidden", "true");
                continue;
            }

            this.slides[i].setAttribute("aria-hidden", "false");
        }
    }

    next() {
        this.setIndex(this.activeIndex + 1);
    }

    previous() {
        this.setIndex(this.activeIndex - 1);
    }

    setIndex(i) {
        if(i < 0 || i > this.slides.length - 1) {
            i = 0;
        }

        this.activeIndex = i;
        this.render();
    }
}
